(function () {
  var dependencies = [
    "ngResource",
    "ui.router",
    "ui.bootstrap",
    "ui.gravatar",
    "ui.utils.masks",
    "permission",
    "permission.ui",
    "idf.br-filters",
    "monospaced.qrcode",
    "angular-clipboard",
    "highcharts-ng",
    "ngFileUpload",
    "daterangepicker",
    "angularMoment",
  ];

  var submodules = [
    "admin.templates",
    "admin.permissions",
    "admin.resources",
    "admin.directives",
    "admin.services",
    "admin.login",
    "admin.home",
    "admin.customers",
    "admin.subscriptions",
    "admin.reports",
    "admin.newsletters",
    "admin.campaigns",
  ];

  var submodules = [
    "admin.templates",
    "admin.permissions",
    "admin.resources",
    "admin.directives",
    "admin.services",
    "admin.login",
    "admin.home",
    "admin.customers",
    "admin.subscriptions",
    "admin.reports",
    "admin.campaigns",
  ];

  angular
    .module("admin", dependencies.concat(submodules))
    .config(function (uibPaginationConfig) {
      uibPaginationConfig.firstText = "Primeira";
      uibPaginationConfig.previousText = "Anterior";
      uibPaginationConfig.nextText = "Próxima";
      uibPaginationConfig.lastText = "Última";
    })
    .config(function ($stateProvider, $urlRouterProvider) {
      $urlRouterProvider.otherwise("/");

      $stateProvider.state("admin", {
        url: "/",
        templateUrl: "views/admin/master.html",
        controller: "AdminCtrl",
        controllerAs: "ctrl",
      });

      $stateProvider.state("logout", {
        url: "/logout",
        controller: function ($state, UserManager) {
          UserManager.abandon();
          $state.go("login");
        },
      });
    })
    .config(function ($sceDelegateProvider) {
      $sceDelegateProvider.resourceUrlWhitelist([
        "self",
        "http://local.canalenergia.com.br:8080/**",
        "http://localhost:8880/**",
        "https://www.canalenergia.com.br/**",
      ]);
    })
    .config(function ($httpProvider) {
      $httpProvider.interceptors.push(function ($q, $injector, config) {
        const state = {
          isRefreshing: false,
          refreshPromise: null,
          refreshAttempted: false,
          isRetrying: false,
        };

        const isApiUrl = (url) => url && url.includes(config.api);
        const isLoginSupervisor = (url) =>
          url && url.includes("auth-backoffice/login");
        const isRefreshUrl = (url) => url && url.includes("/auth/refresh");
        const shouldHandle401 = (rejection) =>
          rejection &&
          rejection.status === 401 &&
          rejection.config &&
          isApiUrl(rejection.config.url) &&
          !isLoginSupervisor(rejection.config.url) &&
          !isRefreshUrl(rejection.config.url);

        const resetState = () => {
          state.isRefreshing = false;
          state.refreshPromise = null;
          state.refreshAttempted = false;
          state.isRetrying = false;
        };

        const logout = (rejection) => {
          const $state = $injector.get("$state");
          const UserManager = $injector.get("UserManager");

          UserManager.abandon();
          $state.go("login");
          resetState();
          return $q.reject(rejection || new Error("Token refresh failed"));
        };

        const refreshToken = () => {
          const $http = $injector.get("$http");
          const UserManager = $injector.get("UserManager");
          const refreshTokenValue = localStorage.getItem(
            "ce-admin-refresh-token"
          );

          if (!refreshTokenValue) {
            return $q.reject(new Error("No refresh token available"));
          }

          state.isRefreshing = true;
          state.refreshAttempted = true;

          state.refreshPromise = $http
            .post(config.api + "/api/v1/auth/refresh", {
              refreshToken: refreshTokenValue,
            })
            .then((res) => {
              const data = res.data.data;
              UserManager.setTokens(data.idToken, data.accessToken);
              state.isRefreshing = false;
              return data;
            })
            .catch((error) => {
              resetState();
              logout(error);
              return $q.reject(error);
            });

          return state.refreshPromise;
        };

        const retryRequest = (originalConfig) => {
          const $http = $injector.get("$http");
          const newAccessToken = localStorage.getItem("ce-admin-access-token");

          if (!newAccessToken) {
            resetState();
            return $q.reject(new Error("No access token after refresh"));
          }

          state.isRetrying = true;
          const retryConfig = angular.copy(originalConfig);
          retryConfig.headers.Authorization = `Bearer ${newAccessToken}`;

          return $http(retryConfig)
            .then((response) => {
              resetState();
              return response;
            })
            .catch((error) => {
              resetState();
              if (error && error.status === 401) {
                return logout(error);
              }
              return $q.reject(error);
            });
        };

        return {
          request: (request) => {
            if (!isApiUrl(request.url)) return request;

            if (isLoginSupervisor(request.url)) {
              resetState();
            }

            const token = localStorage.getItem("ce-admin-access-token");
            if (token) {
              request.headers.Authorization = `Bearer ${token}`;
            }

            return request;
          },

          response: (response) => {
            if (state.isRetrying) state.isRetrying = false;
            return response;
          },

          responseError: (rejection) => {
            if (!shouldHandle401(rejection)) {
              return $q.reject(rejection);
            }

            if (state.refreshAttempted || state.isRetrying) {
              return logout(rejection);
            }

            if (!state.isRefreshing) {
              refreshToken();
            }

            return state.refreshPromise.then(() =>
              retryRequest(rejection.config)
            );
          },
        };
      });
    })

    .run(($transitions, UserManager) => {
      $transitions.onStart({ to: "admin.**" }, (trans) => {
        return UserManager.getCurrent().then(
          (session) => {},
          () => {
            return trans.router.stateService.target("login");
          }
        );
      });
    })
    .run(($locale) => {
      $locale.NUMBER_FORMATS.CURRENCY_SYM += " ";
    });
  for (let submod of submodules) {
    const deps = ["permission", "permission.ui"];
    if (submod === "admin.subscriptions" || submod === "admin.directives") {
      deps.push("admin.services");
    }
    angular.module(submod, deps);
  }
})();
